/**
 * Sort order for BaseTable
 */
const SortOrder = {
  /**
   * Sort data in ascending order
   */
  ASC: 'asc', // 升序
  /**
   * Sort data in descending order
   */
  DESC: 'desc', // 降序
}

export default SortOrder
